import { render, staticRenderFns } from "./AddQcTestRmOrderItemPopUp.vue?vue&type=template&id=a2a81f8c&scoped=true&"
import script from "./AddQcTestRmOrderItemPopUp.vue?vue&type=script&lang=js&"
export * from "./AddQcTestRmOrderItemPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddQcTestRmOrderItemPopUp.vue?vue&type=style&index=0&id=a2a81f8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a81f8c",
  null
  
)

export default component.exports